import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CtbConfService, PageBusquedaObject, CtbConfEmp } from '../ctb-conf/ctb-conf.service';
import { LoginService } from '../../login/login.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-contabilidad-electronica-csd',
  templateUrl: './contabilidad-electronica-csd.component.html',
  styleUrls: ['./contabilidad-electronica-csd.component.css']
})
export class ContabilidadElectronicaCsdComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: CtbConfEmp[];
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private router: Router, private ctaService: CtbConfService, private loginService: LoginService) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.router.navigate(['/contabilidad/catalogo/ctb-csd-conf/lista/' + this.loginService.empresa]);
    this.cargarCatalogo();
  }

  cargarCatalogo() {
  this.busqueda.criteriaSearch['gral_usr_id'] = this.loginService.usuario.id as number;
    this.ctaService.catalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.buscarEnCatalogo();
  }
  eliminar(dtoEliminar: CtbConfEmp): void {
    Swal.fire({
        title: 'Atención',
        text: `¿Está seguro de dar de baja este elemento?`,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.ctaService.delete(dtoEliminar.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
}
